// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Modal_overlay__zS6ET","modal":"Modal_modal__ZuEpq","close":"Modal_close__c_QX2","buttons":"Modal_buttons__juu_c"};